// extracted by mini-css-extract-plugin
export var header = "_wx-1";
export var maskBottom = "_wx-6";
export var maskMiddle = "_wx-7";
export var maskTop = "_wx-5";
export var root = "_wx-0";
export var scrollDownButton = "_wx-3";
export var scrollDownButtonHidden = "_wx-4";
export var viewport = "_wx-2";